import Main from './Containers/Main';
import './Styles/index.scss';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
